module.exports = __webpack_public_path__ + "img/x3.6fdc968d.jpg";